<template>
  <div v-shortkey.once="['ctrl', 'alt', 'f']" @shortkey="updateFullScreen">
    <base-dialog
      :show-dialog="showDialog"
      width="1200"
      :scrollable="true"
      :fullscreen="fullscreen"
    >
      <template v-slot:body>
        <v-card>
          <v-card-title class="mt-0 p-0" style="height: 65px">
            <v-row dense>
              <v-col cols="4">
                <v-text-field
                  :placeholder="$t('placeholders.opcoesItens')"
                  :label="$tc('labels.produto')"
                  class="text-caption ml-1"
                  v-model="searchItens.codigo"
                  @input="searchItem()"
                  @focusin="focused = !focused"
                  @focusout="focused = !focused"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="4" sm="4" md="4" lg="4">
                <div>
                  <c-select
                    class="text-caption ml-1"
                    rotulo="Fabricantes"
                    itemText="text"
                    itemValue="value"
                    :lista="cbManufacturerList"
                    v-model="searchItens.fabricante"
                    @input="searchItem()"
                    @focusin="focused = !focused"
                    @focusout="focused = !focused"
                    :dark="false"
                  />
                </div>
              </v-col>
              <v-col cols="4" sm="4" md="4" lg="4">
                <div>
                  <c-select
                    class="text-caption ml-1"
                    rotulo="Marcas"
                    itemText="text"
                    itemValue="value"
                    :lista="cbBrandList"
                    v-model="searchItens.marca"
                    @input="searchItem()"
                    @focusin="focused = !focused"
                    @focusout="focused = !focused"
                    :dark="false"
                  />
                </div>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="cardText">
            <v-row no-gutters class="cardTextRowTable">
              <v-col cols="12">
                <v-data-table
                  dense
                  dark
                  hide-default-footer
                  :loading="loadingItems"
                  :items="itemListComputed"
                  :headers="listHeader"
                  item-key="CODIGO"
                  :item-class="estilizaLinha"
                  @click:row="clickLine($event)"
                  @update:sort-by="getLinhasTabela"
                  @current-items="setCurrentList"
                  :items-per-page="qntItensTable"
                  :fixed-header="true"
                  :height="heightTable"
                  :show-select="!loadingItems"
                  id="tabelaItens"
                  v-model="selected"
                  :search="search"
                  :custom-filter="filterOnTable"
                >
                  <template v-slot:top>
                    <v-container fluid>
                      <v-text-field
                        v-model="search"
                        class="mt-6"
                        :label="$t('tabelas.filtrar')"
                        dense
                        prepend-inner-icon="mdi-magnify"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-container>
                  </template>

                  <template v-slot:item.item_integracao="{ item }">
                    <span
                      v-if="item.item_integracao != null"
                      class="red--text"
                      >{{ item.item_integracao.INTEGRACAO }}</span
                    >
                    <span v-else class="green--text">Não Possui</span>
                  </template>

                  <template
                    v-slot:item.data-table-select="{
                      item,
                      isSelected,
                      select,
                    }"
                  >
                    <v-simple-checkbox
                      :ripple="false"
                      :value="isSelected"
                      :readonly="item.disableSelect"
                      :disabled="item.disableSelect"
                      @input="select($event)"
                    ></v-simple-checkbox>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }" dense>
                    <td :colspan="headers.length" dense>
                      <v-row dense class="mt-1">
                        <v-col cols="2" dense>
                          <c-input
                            :label="$t('labels.quantidade')"
                            :placeholder="$t('labels.quantidade')"
                            :maxLength="10"
                            v-model="item.quantidade"
                            :type="'number'"
                            :min="quantidadeStepMin(item)"
                            :step="quantidadeStepMin(item)"
                            :disabled="item.disableSelect || loadingItems"
                            :id="item.CODIGO"
                            :isRequired="false"
                            @input="updateQnt(item, $event)"
                            @click="clickLineExpanded(item)"
                            @blur="validaQuantidade(item, $event)"
                            @onfocusout="validaQuantidade(item, $event)"
                            class="text-caption ml-1"
                            hide-details="auto"
                          />
                        </v-col>
                        <v-col cols="2">
                          <span class="text-caption">
                            {{
                              `${$t('labels.quantidadeAbreviado')} ${$t(
                                'labels.orcamento'
                              )}`
                            }}
                            {{
                              getDadosItemMoedas(item)
                                ? getDadosItemMoedas(item).quantidade
                                : 0
                            }}
                          </span>
                        </v-col>
                        <v-col
                          cols="4"
                          v-show="getDadosItemMoedas(item)"
                          class="text-caption"
                        >
                          &nbsp;&nbsp;&nbsp; (Total
                          {{
                            $tc(
                              'labels.produto',
                              getDadosItemMoedas(item)
                                ? getDadosItemMoedas(item).quantidade
                                : 0
                            )
                          }})
                          <span
                            class="text-caption"
                            v-for="(dado, index) in getDadosItemMoedas(item)"
                            :key="index"
                          >
                            <br />
                            {{ dado.valor }}
                          </span>
                        </v-col>
                        <v-col
                          cols="4"
                          v-show="selected.length > 0"
                          class="text-caption"
                        >
                          &nbsp;&nbsp;&nbsp; (Total
                          {{
                            $tc(
                              'labels.produtoSelecionado',
                              getDadosItemMoedas(item)
                                ? getDadosItemMoedas(item).quantidade
                                : 0
                            )
                          }})
                          <span
                            v-for="(i, index) in currenciesList"
                            :key="index"
                            class="text-caption"
                          >
                            <br />
                            {{
                              formatCurrency(
                                i.index,
                                getTotalPorItemSelected(item)
                                  ? getTotalPorItemSelected(item)[0].valor[
                                      i.cifrao
                                    ]
                                  : 0
                              )
                            }}
                          </span>
                        </v-col>
                      </v-row>
                    </td>
                  </template>
                  <template v-slot:item.PRECOITEM="{ item }">
                    <v-chip :color="getColor(item.EMOFERTA)" dark small>
                      {{
                        formatCurrency(
                          moeda,
                          item.PRECOITEM[currenciesList[moeda].cifrao]
                        )
                      }}
                    </v-chip>
                  </template>

                  <template
                    v-slot:item.imagens.image_name="{
                      item,
                    }"
                  >
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-if="item.imagens">
                          <v-btn
                            v-on="on"
                            v-bind="attrs"
                            x-small
                            @click="toogleOverlay(item)"
                          >
                            <v-icon color="blue">mdi-image-outline</v-icon>
                          </v-btn>
                        </span>
                        <span v-else>
                          <v-btn v-on="on" v-bind="attrs" x-small>
                            <span class="red--text">X</span>
                          </v-btn>
                        </span>
                      </template>
                      <span v-if="item.imagens">{{
                        $t('tabelas.verImagem')
                      }}</span>
                      <span v-else>{{ $t('tabelas.semImagem') }}</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:item.SALDOITEM="{ item }">
                    <div class="text-caption">
                      {{
                        item.SALDOITEM - parseInt(item.SALDOITEM, 10) > 0
                          ? formatDecimal(item.SALDOITEM, 4, 2)
                          : formatDecimal(item.SALDOITEM, 0, 0)
                      }}
                    </div>
                  </template>
                  <template v-slot:item.DESCRICAO="{ item }">
                    <div class="text-caption">
                      {{ item.DESCRICAO }}
                    </div>
                  </template>
                  <template v-slot:item.MARCA="{ item }">
                    <div class="text-caption">
                      {{ item.MARCA }}
                    </div>
                  </template>
                  <template v-slot:item.CODIGO="{ item }">
                    <div class="text-caption" id="COLUNACODIGO">
                      {{ item.CODIGO }}
                    </div>
                  </template>
                  <template v-slot:item.UM="{ item }">
                    <div class="text-caption">
                      {{ item.UM }}/{{
                        item.EMBALAGEMVENDA
                          ? parseFloat(item.EMBALAGEMVENDA).toFixed(2)
                          : 1
                      }}
                    </div>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn
              dark
              color="red darken-4"
              :class="
                `${
                  $vuetify.breakpoint.name != 'sm' &&
                  $vuetify.breakpoint.name != 'md'
                    ? 'text-subtitle-2'
                    : 'text-caption'
                } ml-1 px-1 py-1`
              "
              @click="$emit('close')"
            >
              <span>{{ $t('labels.fechar') }}</span>
            </v-btn>
            <span v-show="false">{{ sumSelecteds }}</span>
            <v-btn
              dark
              color="green darken-4"
              :class="
                `${
                  $vuetify.breakpoint.name != 'sm' &&
                  $vuetify.breakpoint.name != 'md'
                    ? 'text-subtitle-2'
                    : 'text-caption'
                } ml-1 px-1 py-1`
              "
              @click="addItens"
              v-if="selected.length > 0"
            >
              <v-icon small>
                mdi-upload
              </v-icon>
              <span> ({{ selected.length }}) </span>
            </v-btn>
            <v-spacer
              v-if="
                $vuetify.breakpoint.name != 'sm' &&
                  $vuetify.breakpoint.name != 'md'
              "
            ></v-spacer>
            <span
              v-if="
                $vuetify.breakpoint.name != 'sm' &&
                  $vuetify.breakpoint.name != 'md'
              "
            >
              <v-chip dark>
                <span>
                  {{ itemListComputed.length }}/{{ pagination.total }}
                </span>
              </v-chip>
            </span>
          </v-card-actions>
          <!-- Imagem overlay Component-->
          <overlayItem
            :isVisible="overlay.overlay"
            :isAbsolute="overlay.absolute"
            :imagesList="imagesList"
            :especificacoes="overlay.especificacoes"
            :item="overlay.item"
            :opacity="0.8"
            v-model="overlay.model"
            @closeOverlay="closeOverlay"
          />
          <v-menu
            v-model="showMenu"
            :position-x="contextMenuConfig.positionX"
            :position-y="contextMenuConfig.positionY"
            transition="scale-transition"
            rounded="lg"
            nudge-top
            absolute
            offset-y
            light
          >
            <v-list dense>
              <v-list-item
                v-for="checkbox in contextMenuConfig.items.checkboxes"
                :key="checkbox.value"
                @click="
                  selectOption($event, checkbox)
                  checkbox.checked = !checkbox.checked
                "
              >
                <v-list-item-action>
                  <v-checkbox
                    v-model="checkbox.checked"
                    @click="
                      selectOption($event, checkbox)
                      checkbox.checked = !checkbox.checked
                    "
                  >
                  </v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t(`labels.${checkbox.label}`) }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-for="option in contextMenuConfig.items.options"
                :key="option.value"
                @click="selectOption($event, option)"
              >
                <v-list-item-action>
                  <v-icon @click="selectOption($event, option)">
                    {{ option.icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t(`labels.${option.label}`) }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-card>
      </template>
    </base-dialog>
    <message-dialog
      :showDialog="showMessageDialog"
      @close="showMessageDialog = false"
      :message="messageToDialog"
    />
    <confirm :persistent="true" ref="confirm" v-model="confirm"></confirm>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import baseDialog from '@/components/shared/base-dialog/BaseDialog'
import { currencyMixin } from '@/mixins/object/currency/CurrencyMixin'
import { flagsMixin } from '@/mixins/object/flags/FlagsMixin'
import cInput from '@/components/shared/base-input/BaseInput'
import cSelect from '@/components/shared/base-input/BaseSelect'
import { translateList } from '@/utils/utils'
import Confirm from '@/components/shared/base-dialog/Confirm.vue'

export default {
  mixins: [currencyMixin, flagsMixin],
  components: {
    baseDialog,
    cInput,
    cSelect,
    Confirm,
    overlayItem: () => import('@/components/shared/base-overlay/BaseOverlay'),
    MessageDialog: () =>
      import('@/components/shared/base-dialog/MessageDialog'),
  },
  computed: {
    isIntegration() {
      return this.$router.currentRoute.path.includes('integracao')
    },
    onlyItemsSelected: {
      get() {
        return this.selected.length > 0 ? this.onlySelected : false
      },
      set(value) {
        this.onlySelected = value
      },
    },
    qntItensTable: {
      get() {
        return this.itemListComputed.length
      },
    },
    itemListComputed: function() {
      if (this.itemList.total == 0 || !this.itemList) return []
      let r = this.itemList.map((item) => ({
        ...item,
        disableSelect:
          // item.item_integracao == null &&
          item.PRECOITEM[this.currenciesList[this.moeda].cifrao] > 0 ||
          !this.getFlagSetado('BloqueiaPrecoZeroNoOrcamento')
            ? false
            : true,
      }))
      if (this.onlySelected && this.selected.length > 0) return this.selected
      else if (this.selected.length > 0 && !this.existSearch()) {
        this.selected.map((e) => {
          const item = r.findIndex((ele) => e.CODIGO == ele.CODIGO)
          if (item == -1) r = r.concat(e)
        })
      }
      return r
    },
    positionSelectedLine() {
      return this.rowSelected ? this.rowSelected.offsetTop : undefined
    },
    // Ver o breakpoint da página
    heightTable() {
      let breakpointName = this.$vuetify.breakpoint.name
      let size = this.updateHeightTable(breakpointName)
      return size ?? 450
    },
    // Item Module
    ...mapState('itemModule', ['itemList', 'loadingItems', 'pagination']),
    ...mapState('pdvBalcaoModule/orderModule', ['order']),
    ...mapState('pdvBalcaoModule/orderItensModule', ['orderItens']),
    //System Module
    ...mapGetters({
      currenciesList: 'systemModule/getSystemCurrencies',
      cbManufacturerList: 'manufacturerModule/getCbList',
      cbBrandList: 'brandModule/getCbList',
    }),
    listHeader() {
      const header = [
        { text: '', value: 'data-table-expand' },
        {
          label: 'codigo',
          text: 'Código',
          value: 'CODIGO',
        },
        { text: 'Integração', value: 'item_integracao' },
        {
          text: 'UM',
          value: 'UM',
        },
        {
          label: 'descricao',
          text: 'Descrição',
          value: 'DESCRICAO',
        },
        {
          label: 'marca',
          text: 'Marca',
          value: 'MARCA',
        },
        {
          label: 'preco',
          text: 'Preço ',
          value: 'PRECOITEM',
        },
        {
          label: 'imagem',
          text: 'Imagem',
          value: 'imagens.image_name',
        },
        {
          label: 'saldo',
          text: 'Saldo',
          value: 'SALDOITEM',
        },
      ]

      return translateList(header)
    },
    indexPriceTypes() {
      let index
      switch (this.tipoPreco) {
        case 'PRECOVAREJO':
          index = 0
          break
        case 'PRECOATACADO':
          index = 1
          break
        case 'PRECOESPECIAL':
          index = 2
          break
        case 'PRECOESPECIAL2':
          index = 3
          break
        case 'PRECOESPECIAL3':
          index = 4
          break
        default:
          index = 0
          break
      }
      return index
    },
    priceTypes() {
      let defaultList = [
        { text: 'Preço Varejo', value: 'PRECOVAREJO' },
        { text: 'Preço Atacado', value: 'PRECOATACADO' },
        { text: 'Preço Especial', value: 'PRECOESPECIAL' },
      ]
      if (this.getFlagSetado('PrecoEspecial23')) {
        let special23List = [
          { text: 'Preço Especial 2', value: 'PRECOESPECIAL2' },
          { text: 'Preço Especial 3', value: 'PRECOESPECIAL3' },
        ]
        // concatena duas listas
        Array.prototype.push.apply(defaultList, special23List)
      }
      return defaultList
    },
    getDadosMoeda: {
      get() {
        return this.currenciesList.filter((e) => e.index == this.order.moeda)[0]
      },
      set() {
        this.indexMoeda = this.currenciesList.filter((e) => {
          if (e.index == this.order.moeda) {
            this.indexMoeda = e.index
          }
        })
      },
    },
  },
  data: () => {
    return {
      messageToDialog: [],
      showMessageDialog: false,
      confirm: false,
      totalItensPorMoeda: [],
      firstCheck: true,
      onlySelected: false,
      showMenu: false,
      focused: false,
      fullscreen: false,
      search: '',
      currentList: [],
      searching: false,
      page: 1,
      disabledCount: 0, // quantidade de linhas não selecionaveis na tabela
      selected: [],
      dadosRodape: [],
      expanded: [],
      tipoPreco: '',
      moeda: 0,
      indexMoeda: 0,
      timer: null,
      timerScroll: null,
      contextMenuConfig: {
        positionX: 0,
        positionY: 0,
        items: {
          checkboxes: [
            {
              label: 'itensSelecionados',
              title: 'Selecionados',
              checked: false,
              value: 'itensselecionados',
            },
            {
              label: 'comFotos',
              title: 'Com fotos',
              checked: false,
              value: 'socomfotos',
            },
          ],
          options: [
            {
              label: 'saldoFiliais',
              title: 'Saldos Filiais',
              value: 'saldosfiliais',
              icon: 'mdi-warehouse',
            },
          ],
        },
      },
      searchItens: {
        marca: '',
        fabricante: '',
        codigo: '',
        filtroSaldo: true,
        filtroImagens: false,
        filtroOferta: false,
      },
      overlay: {
        overlay: false,
        cycle: false,
        absolute: false,
        color: 'dark',
        model: 0,
        especificacoes: '',
        item: {},
      },
      imagesList: [],
      elementoTableWraper: [],
      //Linha selecionada
      rowSelected: [],
      //Linha expandida selecionada
      rowExpandedSelected: [],
      //Linhas da tabela
      rows: [],
      //Linhas expandidas da tabela
      rowsExpanded: [],
      indexRowSelected: -1,
      indexRowExpandedSelected: -1,
    }
  },
  created() {
    const self = this

    if (this.itemListComputed == [] || this.itemListComputed.length == 0) return
    this.itemListComputed.map((item) => {
      if (item.disableSelect) self.disabledCount += 1
    })
  },
  async mounted() {
    try {
      this.addEventos()
      // setar nas propriedades locais, não alterar estado do orçamento

      if (this.isIntegration && this.integration && this.integration != {})
        this.tipoPreco = this.priceTypes.filter(
          (v) =>
            v.text
              .toLowerCase()
              .lastIndexOf(this.integration.TIPOPRECO.toLowerCase()) != -1
        )[0].value
      else this.tipoPreco = this.order.tipoPreco
      this.moeda = this.order.moeda
      if (this.currency.length == 0) await this.getcurrencyAPI({ page: 1 })
      // await this.getDados()
      if (this.cbBrandList.length <= 0) this.getBrandsAPI({ todos: 'S' })
      if (this.cbManufacturerList.length <= 0)
        this.getManufacturersAPI({ todos: 'S' })
      // para marcar a primeira linha da tabela ou em uma eventua linha ja selecionada
      this.goToTableTop(0, this.indexRowSelected)
      await this.confirmGetSelectedItems()

      console.log('entrou')
    } catch (error) {
      this.$toasted.error(error, { duration: null })
    }
  },
  destroyed() {
    document.removeEventListener('contextmenu', this.contextMenu)
    document.removeEventListener('scroll', this.handleScroll)
    document.removeEventListener('keydown', this.configuraLinha)
    document.removeEventListener('keyup', this.configuraLinhaKeyUp)
  },
  methods: {
    sumSelecteds() {
      this.checkItemsSelectedSaved()
      let soma = []
      let ret = []
      this.selected.forEach((item) => {
        ret = []
        let preco = 0
        let currencyOrcamento = this.currenciesList.filter(
          (e) => e.index == this.order.moeda
        )[0]
        preco = this.convertePreco(
          this.order.moeda,
          item.PRECOITEM[currencyOrcamento.cifrao]
        )
        let value = 0
        this.currenciesList.forEach((currency) => {
          let qnt = item.quantidade ? parseFloat(item.quantidade) : 1
          value = this.calculaCambio(currency, preco) * qnt
          ret[currency.cifrao] = value
        })
        let obj = []
        obj.codigo = item.CODIGO
        obj.valor = ret
        soma.push(obj)
        this.updateTotalSelectedItems(soma)
      })
      return soma
    },
    existSearch() {
      let exist = false
      const keys = Object.keys(this.searchItens)
      keys.map((e) => {
        if (this.searchItens[e] != '' && this.searchItens[e]) exist = true
      })
      return exist
    },
    updateTotalSelectedItems(somaItems) {
      this.totalItensPorMoeda = somaItems
    },
    getTotalPorItemSelected(item) {
      if (this.totalItensPorMoeda.length < 1) return
      const itemSelected = this.totalItensPorMoeda.filter((e) => {
        if (e.codigo == item.CODIGO) {
          return e
        }
      })
      if (itemSelected.length > 0) return itemSelected
      return
    },
    /*
     * Salva os itens selecionados no SELECT, no localstorage com a chave 'selectedItemsPDV'
     */
    saveSelectedItems(length) {
      if (length < 1) {
        return null
      }
      const c = []
      this.selected.map((e) => {
        let qnt = e.quantidade ?? e.EMBALAGEMVENDA
        c.push({
          ...e,
          quantidade: parseFloat(qnt ?? 1),
        })
      })
      localStorage.setItem(
        'selectedItems' + this.componentOwner,
        btoa(JSON.stringify(c))
      )
      return length
    },
    /*
     * Verifica se existe itens selecionados no localstorage
     * A variável firstCheck verifica se é a primeira que está sendo verificado
     *  o localstorage. Apenas quando for false vai remover os itens selecionados
     */
    async checkItemsSelectedSaved() {
      const retorno = this.saveSelectedItems(this.selected.length)
      if (!retorno && !this.firstCheck) this.removeItemsSelecteds()
      this.firstCheck = false
    },
    /*
     * Recupera os itens selecionados salvos na localstorage com a chave 'selectedItemsPDV'
     */
    async getSelectedItemsSaved() {
      const itemsbase64 = await localStorage.getItem(
        'selectedItems' + this.componentOwner
      )
      if (itemsbase64) {
        const items = await JSON.parse(atob(itemsbase64))
        return items
      }
      return
    },
    /*
     * Atualiza os itens selecionados, adicionando a quantidade no array selected
     */
    async updateItemsSelected() {
      const items = await this.getSelectedItemsSaved()
      if (!items) return
      let array = []
      let ret = {}
      items.forEach((ele) => {
        const index = this.itemListComputed.findIndex(
          (e) => e.CODIGO == ele.CODIGO
        )
        if (index > -1) {
          this.itemListComputed[index].quantidade = ele.quantidade
        }
        ret = {
          ...ele,
        }
        array.push(ret)
      })
      this.selected = array
      return this.selected
    },
    /*
     * Limpa os itens selecionados do localstorage com a chave 'selectedItemsPDV'
     */
    removeItemsSelecteds() {
      localStorage.removeItem('selectedItems' + this.componentOwner)
    },
    /*
     * Abre tela de confirmação penguntando se quer recuperar os itens selecionados
     * salvos no localstorage com a chave 'selectedItemsPDV'
     */
    async confirmGetSelectedItems() {
      const items = await this.getSelectedItemsSaved()
      if (!items || items.length < 1 || !this.$refs.confirm) return
      if (
        await this.$refs.confirm.open(
          this.$i18n.t('labels.recuperar'),
          this.$i18n.t('dialogs.recuperarItens')
        )
      ) {
        this.updateItemsSelected()
      } else {
        this.removeItemsSelecteds()
        return
      }
    },
    /*
     * Abre modal para informar um ambiente
     */
    setarAmbiente($e) {
      this.showSelectAmbienteDialog = false
      if ($e.length > 0) this.ambienteInformado = $e
      this.$toasted.info(
        `${this.$t('labels.ambiente')} ${this.ambienteInformado}`
      )
    },
    /*
     * Seta o step do campo quantidade de acordo o campo EMBALAGEMVENDA do item.
     * Se não houver EMBALAGEMVENDA, o padrão é 1
     */
    quantidadeStepMin: function(item) {
      return item.EMBALAGEMVENDA ?? 1
    },
    /*
     * Filtra os itens que já estão na tela SEM fazer busca na API
     */
    filterOnTable(value, search) {
      return (
        value != null &&
        search != null &&
        typeof value === 'string' &&
        value
          .toString()
          .toLocaleUpperCase()
          .indexOf(search.toLocaleUpperCase()) !== -1
      )
    },
    /*
     * Atualiza a propriedade currentList da data-table
     */
    setCurrentList(value) {
      this.currentList = value ?? []
    },
    /*
     * Estiliza a cor das linhas da tabela
     */
    estilizaLinha(item) {
      let estiloLinha = 'linhaTabela'
      if (item.DESTAQUECOR) {
        estiloLinha += ' yellow--text' // trazer informação da cor do item
      } else if (this.getFlagSetado('ItemSaldoMinimoEmVermelho')) {
        if (parseFloat(item.SALDOITEM) <= parseFloat(item.SALDOMINIMO) ?? 0)
          estiloLinha += ' red--text font-weight-black'
      }
      return estiloLinha
    },
    ...mapActions({
      getItemsAPI: 'itemModule/getItens',
      getcurrencyAPI: 'currencyModule/getCurrency',
      addOrderItem: 'pdvBalcaoModule/orderItensModule/addOrderItem',
      getBrandsAPI: 'brandModule/getBrands',
      getManufacturersAPI: 'manufacturerModule/getManufacturers',
      showLoadingDialog: 'dialogModule/setShowLoadingDialog',
      setLoadingDialogMessage: 'dialogModule/setLoadingDialogMessage',
    }),
    /*
     * Captura as linhas da tabela de itens e adiciona os eventos de teclado e scroll
     */
    addEventos() {
      try {
        // Captura a tabela de itens para e adiciona o evento de scroll
        let tabelaItens = document.getElementById('tabelaItens')

        this.elementoTableWraper = tabelaItens
          ? tabelaItens.getElementsByClassName('v-data-table__wrapper')
          : null
        if (this.elementoTableWraper && this.elementoTableWraper[0]) {
          this.elementoTableWraper[0].addEventListener(
            'scroll',
            this.handleScroll
          )
          // Captura as linhas da tabela de itens e adiciona o evento keydown
          this.getLinhasTabela()
        }
        if (tabelaItens)
          tabelaItens.addEventListener('contextmenu', this.contextMenu, false)
        document.addEventListener('keydown', this.configuraLinha, false)
        document.addEventListener('keyup', this.configuraLinhaKeyUp, false)
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },

    // Captura as linhas da tabela de itens e adiciona o evento keydown
    async getLinhasTabela() {
      try {
        await this.desmarcaLinha()
        await this.$nextTick()

        this.rows = this.elementoTableWraper[0]
          .getElementsByTagName('table')[0]
          .getElementsByTagName('tbody')[0]
          .getElementsByClassName('linhaTabela')

        await this.goToTableTop()
        await this.$nextTick()

        /*
        Deve ser verificado currentList para não dar erro ao carregar
        Trecho abaixo é necessário ao fazer o sort nas colunas e buscar o saldo do item focado
      */
        if (this.currentList.length > 0) {
          this.updateRodapeSelect()
        }
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
    /*
     * Controla a tecla arrowUp(Seta para CIMA) quando a tabela de itens está em foco
     */
    arrowUp() {
      try {
        if (this.indexRowExpandedSelected > -1) return

        if (this.indexRowSelected > -1) {
          let newIndex = parseInt(this.indexRowSelected) - parseInt(1)
          this.setIndexRowSelected(newIndex)
          let pos = this.rowSelected.getBoundingClientRect()

          if (
            this.rowSelected.offsetTop <
            this.elementoTableWraper[0].scrollTop + pos.height
          )
            this.goTo(pos.height, 'up')
          if (newIndex == 0) this.rowSelected.scrollIntoView(false)
        } else this.goToTableTop()
      } catch (error) {
        this.$toasted.error(error)
      }
    },
    /*
     * Controla a tecla arrowDown(Seta para BAIXO) quando a tabela de itens está em foco
     */
    arrowDown() {
      try {
        if (this.indexRowExpandedSelected > -1) return

        if (this.indexRowSelected < this.rows.length - 1) {
          let newIndex = parseInt(this.indexRowSelected) + parseInt(1)
          this.setIndexRowSelected(newIndex)
          let pos = this.rowSelected.getBoundingClientRect()
          if (pos.top > this.elementoTableWraper[0].clientHeight)
            this.goTo(pos.height, 'down')
        }
      } catch (error) {
        this.$toasted.error(error)
      }
    },
    /*
     * Controla a tecla arrowLeft(Seta para ESQUERDA) quando a tabela de itens está em foco
     */
    arrowLeft() {
      let indexItemExpanded = this.getItemRowExpandedSelected().index
      if (indexItemExpanded > -1) this.expanded.splice(indexItemExpanded, 1)
      this.cleanRowExpandedSelected()
      let index = this.getItemRowSelected().index
      this.setIndexRowSelected(index)
    },
    /*
     * Controla a tecla arrowRight(Seta para DIREITA) quando a tabela de itens está em foco
     */
    arrowRight() {
      let item = this.getItemRowSelected().item
      if (item) {
        let itemExiste = this.expanded.filter(
          (ele) => ele.CODIGO == item.CODIGO
        )
        if (itemExiste.length == 0) {
          this.expanded.push(item)
        } else {
          //Item já expandido
          let indexItemExpanded = this.getItemRowExpandedSelected().index
          this.setIndexRowExpandedSelected(indexItemExpanded)
          let elementoQuantidade = document.getElementById(item.CODIGO)
          elementoQuantidade.focus()
        }
      }
      this.setIndexRowSelected(this.indexRowSelected)
      this.updateRowsExpanded()
    },
    /*
     * Controla a tecla space(espaço) quando a tabela de itens está em foco
     */
    space() {
      let codigoItem = this.getCodigoItemRowSelected()
      let item = this.itemListComputed.filter((c) => c.CODIGO == codigoItem)
      if (item.length > 0 && !item[0].disableSelect) {
        let itemSelecionado = this.selected.filter(
          (e) => e.CODIGO == item[0].CODIGO
        )
        if (itemSelecionado.length > 0) this.desmarcaItemSelected(item[0])
        else {
          let i = this.itemListComputed.filter(
            (e) => e.CODIGO == item[0].CODIGO
          )
          if (!i[0].disableSelect) this.selectItem(item[0])
        }
      }
      this.arrowDown()
    },
    /*
     * Controla a tecla enter quando a tabela de itens está em foco
     */
    enter() {
      let item = this.getItemRowExpandedSelected()
      const ele = document.getElementById(this.getCodigoItemRowSelected())
      if (ele) {
        if (this.validaQuantidade(item.item ?? item, ele.value)) {
          this.arrowLeft()
          this.arrowDown()
        }
      } else {
        this.arrowDown()
      }
    },
    /*
     * Controla o scroll da tabela
     */
    goToTableTop(coordinate = 0, indexLine = 0) {
      this.elementoTableWraper[0].scrollTop = coordinate
      this.$nextTick(function() {
        this.setIndexRowSelected(indexLine)
      })
    },
    /*
     * Controla algumas teclas especiais, quando a tabela de itens está em foco
     */
    configuraLinhaKeyUp: function(event) {
      if (this.focused) return

      const keys = ['Home', 'End', 'PageDown', 'PageUp']
      const { code, ctrlKey } = event

      if (keys.lastIndexOf(code) == -1) return

      let nextLine = 0
      let altura = 0

      const {
        scrollTop,
        scrollHeight,
        clientHeight,
      } = this.elementoTableWraper[0]

      const endScroll = scrollHeight - Math.abs(scrollTop) === clientHeight

      let alignTo = {
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      }

      switch (code) {
        case 'Home':
          if (!ctrlKey) return
          this.goToTableTop()
          break

        case 'PageUp':
          altura = this.positionSelectedLine - clientHeight

          for (let index = this.indexRowSelected; index >= 0; index--) {
            const position = this.rows[index].offsetTop
            nextLine = index
            if (position < altura) {
              break
            }
          }

          this.goToTableTop(altura, nextLine)
          this.$nextTick(function() {
            this.rowSelected.scrollIntoView(alignTo)
          })
          break

        case 'End':
          if (!ctrlKey) return
          nextLine = this.rows ? this.rows.length - 1 : 0
          this.goToTableTop(scrollHeight, nextLine)
          break

        case 'PageDown':
          altura = this.positionSelectedLine + clientHeight

          for (
            let index = this.indexRowSelected + 1;
            index < this.rows.length;
            index++
          ) {
            const position = this.rows[index].offsetTop
            nextLine = index
            if (position > altura) {
              break
            }
          }
          if (nextLine > 0) {
            this.goToTableTop(altura, nextLine)

            if (this.positionSelectedLine > 0 && !endScroll) {
              this.$nextTick(function() {
                this.rowSelected.scrollIntoView(alignTo)
              })
            } else if (endScroll) {
              alignTo.block = 'end'
              this.$nextTick(function() {
                this.rowSelected.scrollIntoView(alignTo)
              })
            }
          }
          break

        default:
          break
      }
      this.$nextTick(function() {
        this.updateRodapeSelect()
      })
    },
    /*
     * Controla as teclas de navegação na tabela (ArrowUp, ArrowDown, ArrowLeft, ArrowRight, Space, Enter e NumpadEnter)
     * quando a tabela de itens está em foco
     */
    configuraLinha: function(event) {
      if (this.focused) return

      // não prosseguir com alguma dessas teclas pressionadas
      if (event.ctrlKey || event.altKey || event.shiftKey) return

      const teclas = [
        'ArrowUp',
        'ArrowDown',
        'Space',
        'ArrowRight',
        'ArrowLeft',
        'Enter',
        'NumpadEnter',
      ]
      const teclaPressionada = {
        ArrowUp: this.arrowUp,
        ArrowDown: this.arrowDown,
        ArrowRight: this.arrowRight,
        ArrowLeft: this.arrowLeft,
        Space: this.space,
        Enter: this.enter,
        NumpadEnter: this.enter,
      }

      let p = teclas.filter((e) => e == event.code)

      if (p.length > 0) {
        teclaPressionada[p]()
        this.$nextTick(function() {
          this.updateRodapeSelect()
        })
      }
    },

    /*
     * Atualiza o array rowsExpanded com as linhas expandidas da tabela
     */
    updateRowsExpanded() {
      this.rowsExpanded = this.elementoTableWraper[0]
        .getElementsByTagName('table')[0]
        .getElementsByTagName('tbody')[0]
        .getElementsByClassName('v-data-table__expanded__content')
    },
    /*
     * Retorna o item da linha quando está expandida e selecionada
     */
    getItemRowExpandedSelected() {
      let codigoItem = this.getCodigoItemRowSelected()
      let retorno = {}
      this.expanded.filter((e, index) => {
        if (e.CODIGO == codigoItem) {
          retorno.item = e
          retorno.index = index
        }
      })
      return retorno
    },
    /*
     * Controla a navegação por paginação para as teclas PageUp e PageDown
     */
    goTo(coordinate, type = 'up') {
      type == 'down'
        ? (this.elementoTableWraper[0].scrollTop += coordinate)
        : (this.elementoTableWraper[0].scrollTop -= coordinate)
    },
    /*
     * Atualiza o index da linha selecionada e o array rowSelected com a linha selecionada
     */
    setIndexRowSelected(index) {
      this.desmarcaLinha()

      if (index == -1) this.indexRowSelected = 0
      else this.indexRowSelected = index

      this.rowSelected = this.rows[this.indexRowSelected]

      this.$nextTick(function() {
        this.marcaLinha()
      })
    },
    /*
     * Atualiza o índice da linha expandida e selecionada
     */
    setIndexRowExpandedSelected(index) {
      this.indexRowExpandedSelected = index
      this.setRowExpandedSelected()
    },
    /*
     * Atualiza o array rowExpandedSelected que controla a linha expandida selecionada
     */
    setRowExpandedSelected() {
      if (this.indexRowExpandedSelected == -1) this.indexRowExpandedSelected = 0
      this.rowExpandedSelected = this.rowsExpanded[
        this.indexRowExpandedSelected
      ]
    },
    /*
     * Limpa o array rowExpandedSelected e seta o indexRowExpandedSeleted == -1
     *  quando a linha selecionada recolhe a linha expandida
     */
    cleanRowExpandedSelected() {
      this.rowExpandedSelected = []
      this.indexRowExpandedSelected = -1
    },
    /*
     * Captura o código do item da linha selecionada
     */
    getCodigoItemRowSelected() {
      try {
        let codigoItem = this.rowSelected
          .getElementsByTagName('td')[2]
          .getElementsByTagName('div')[0].innerText
        return codigoItem
      } catch (error) {
        this.$toasted.error(error)
      }
    },
    /*
     * Retorna o item da linha selecionada
     */
    getItemRowSelected() {
      let codigoItem = this.getCodigoItemRowSelected()
      let retorno = {}
      this.currentList.filter((c, index) => {
        if (c.CODIGO == codigoItem) {
          retorno.item = c
          retorno.index = index
        }
      })
      return retorno
    },
    /*
     * Adiciona uma classe de cor quando a linha está selecionada
     */
    marcaLinha(type = 'linhaItem') {
      this.$nextTick(function() {
        let elemento =
          type == 'linhaItem' ? this.rowSelected : this.rowExpandedSelected
        if (elemento) elemento.classList.add('focused-line')
      })
    },
    /*
     * Remove a classe de cor quando a linha for DESelecionada
     */
    desmarcaLinha(type = 'linhaItem') {
      let elemento =
        type == 'linhaItem'
          ? this.rows[this.indexRowSelected]
          : this.rowsExpanded[this.indexRowExpandedSelected]
      if (elemento) elemento.classList.remove('focused-line')
    },
    /*
     * Função chamada pelo evento Scroll que realiza busca de itens na API
     * conforme a posição do scroll da tabela na tela
     */
    handleScroll: function(e) {
      this.scrollTable(e)
      /*
       *    e.target.scrollHeight é o altura total da página com a parte scrollable
       *   e.target.scrollTop é o total que já foi realizado o scrool até o top da página
       *  e.target.clientHeight é o tamanho da tela do cliente
       */
      if (
        this.scrollTable(e) < 300 &&
        this.pagination.currentPage < this.pagination.lastPage &&
        !this.onlyItemsSelected
      ) {
        clearTimeout(this.timerScroll)
        this.timerScroll = setTimeout(() => {
          if (this.searching == false) {
            this.searchItem('scroll')
          }
        }, 200)
      }
    },
    /*
     * Retorna a posição atual do scroll da tabela
     */
    scrollTable(e) {
      let elem = e.target ? e.target : e[0]
      let value = elem.scrollHeight - Math.abs(elem.scrollTop)
      let posicaoScroll = value - elem.clientHeight
      return posicaoScroll
    },
    /*
     * Remove o item da array selected que controla os itens selecionados da tabela
     */
    desmarcaItemSelected(item) {
      this.selected = this.selected.filter((e) => e.CODIGO !== item.CODIGO)
    },
    /*
     * Atualiza a moeda dos itens de acordo a moeda selecionada no select
     */
    updateCurrency(e) {
      this.moeda = this.currenciesList[e ? e.index : 0].index
    },
    /*
     * Função que controla o clique nas linhas da tabela de itens
     */
    clickLine($event) {
      this.currentList.filter((e, index) => {
        if (e.CODIGO == $event.CODIGO) {
          this.desmarcaLinha()
          this.setIndexRowSelected(index)
        }
      })
      this.updateRodapeSelect($event)
    },
    /*
     * Função que controla o clique nas linhas EXPANDIDAS da tabela de itens
     */
    clickLineExpanded($event) {
      this.setIndexRowExpandedSelected(0)
      this.clickLine($event)
    },
    /*
     * Recebe informações dos dialogs (Filtro no da oferta e Informa quantidade em itens)
     */
    async objectPin(type, object) {
      try {
        switch (type) {
          case 'nameoferta':
            this.showDialognameoferta = false
            this.searchItens.nameOferta = object.toUpperCase()
            this.getDados()
            break
          case 'informaQuantidade':
            this.updateQntItemsSelected(object)
            break
        }
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.showLoadingDialog(false)
      }
    },
    /*
     * Informa uma mesma quantidade nos itens selecionados
     */
    updateQntItemsSelected(quantidade) {
      this.selected.map((e) => {
        const index = this.itemListComputed.findIndex(
          (ele) => e.CODIGO == ele.CODIGO
        )
        let qnt = this.validaQuantidade(e, parseFloat(quantidade))
        e.quantidade = parseFloat(qnt)
        if (index != -1) {
          this.itemListComputed[index].quantidade = parseFloat(qnt)
        }
      })
    },
    /*
     * Função de adicionar item por item ao orçamento
     */
    pinObject(item) {
      if (this.order.moeda !== this.moeda) {
        this.$toasted.error(
          this.$t('validation-messages.moedaDiferenteOrcamento')
        )
        return
      }
      if (this.order.tipoPreco !== this.tipoPreco) {
        this.$toasted.error(
          this.$t('validation-messages.tipoPrecoDiferenteOrcamento')
        )
        return
      }
      if (item.EMBALAGEMVENDA)
        item.quantidade = parseFloat(item.EMBALAGEMVENDA).toFixed(2)
      else item.quantidade = 1
      if (this.ambienteInformado.length > 0)
        item.COMPLEMENTO = this.ambienteInformado
      this.$emit('object-pin', item)
    },
    /*
     * Retorna os dados de um item que já está gravado no orçamento
     * Quantidade e o valor nas moeda disponíveis no gestão
     */
    getDadosItemMoedas(item) {
      let dados = []
      let preco = 0
      const orderItem = this.orderItens.filter((e) => e.ITEM == item.CODIGO)
      if (orderItem.length < 1) return
      let moedaorcamento = parseInt(orderItem[0].MOEDAORCAMENTO)
      if (moedaorcamento != 0) {
        preco = parseFloat(
          this.convertePreco(moedaorcamento, orderItem[0].PRECO)
        )
      } else {
        preco = parseFloat(orderItem[0].PRECO)
      }
      this.currenciesList.map((e) => {
        let valorUnitario =
          this.calculaCambio(e, preco) * orderItem[0].QUANTIDADE
        let valorItem = this.formatCurrency(e.index, valorUnitario)
        dados.push({
          index: e.index,
          valor: valorItem,
        })
      })
      dados.quantidade = parseFloat(orderItem[0].QUANTIDADE)
      return dados
    },
    /*
     * Converte o preço do item quando a moeda do orçamento é diferente de 0
     */
    convertePreco(moedaorcamento, valor) {
      let cambio = this.getCambioAtual(moedaorcamento)
      let valorMoeda0 = parseFloat(valor) * parseFloat(cambio)

      return valorMoeda0
    },
    /*
     * Atualiza a quantidade do item selecionado sempre que houver mudança no valor do input quantidade
     */
    updateQnt(item, quantidade) {
      if (!quantidade) return
      this.clickLineExpanded(item)
      let index = this.selected.findIndex((e) => item.CODIGO == e.CODIGO)
      let index1 = this.itemList.findIndex((e) => item.CODIGO == e.CODIGO)
      if (index === -1) {
        this.selectItem(item)
      } else {
        let copySelected = this.selected
        copySelected[index].quantidade = quantidade
        this.selected = []
        this.selected = copySelected
      }
      if (index1) {
        this.itemList[index1].quantidade = quantidade
      }
    },
    /*
     * Adiciona o item ao array selected que controla os itens selecionados
     */
    selectItem(item) {
      if (this.ambienteInformado.length > 0)
        item.COMPLEMENTO = this.ambienteInformado
      this.selected.push(item)
    },
    /*
     * Valida a quantidade informada no item de acordo o campo EMBALAGEMVENDA
     * quando está setado a flag 'VerificaEmbalagensNosPrecos'
     * Quando for inválida, retorna uma sugestão de quantidade correta
     */
    validaQuantidade(item, $event) {
      if (!$event) return
      let quantidade =
        $event && $event.target && $event.target.value
          ? $event.target.value
          : $event
      let qntEmbalagem = item.EMBALAGEMVENDA ?? 1
      let result =
        parseFloat(quantidade).toFixed(2) / parseFloat(qntEmbalagem).toFixed(2)
      let diff = Math.round(result) - result
      if (
        (diff > 0.01 || diff < -0.01) &&
        this.getFlagSetado('VerificaEmbalagensNosPrecos')
      ) {
        let sugestaoQnt = (Math.ceil(result) * qntEmbalagem).toFixed(2)
        let i = this.selected.filter((e) => e.CODIGO == item.CODIGO)
        i[0].quantidade = sugestaoQnt
        this.$toasted.error(
          'Item: [' +
            item.CODIGO +
            '] ' +
            this.$t('validation-messages.quantityMultiplies', {
              quantidade: qntEmbalagem,
            })
        )
        this.$toasted.error(
          this.$t('validation-messages.quantityAlter', {
            quantidade: sugestaoQnt,
          }) +
            ' ' +
            item.UM
        )
        return sugestaoQnt
      }
      return quantidade
    },
    /*
     * Retorna a cor verde quando o item em oferta
     */
    getColor(oferta) {
      if (oferta === 'S') return 'green'
      else return ''
    },
    addItens() {
      this.removeItemsSelecteds()
      this.$emit('addItens', this.selected)
      this.searchItem()
      if (this.componentOwner != 'PDV') this.selected = []
    },
    /*
     * Controla os filtros para busca na API
     */
    prepareSearchQuery() {
      this.tipoPreco = this.priceTypes[this.indexPriceTypes].value
      let obj = {
        page: this.page,
        perPage: 30,
        tipoPreco: this.indexPriceTypes,
        moedaBalcao: this.moeda,
        condicaoPgto: this.order.condicaoPgto,
        // pdvBalcao: true,
        comitemintegracao: 'S',
        marca: this.searchItens.marca ?? null,
        fabricante: this.searchItens.fabricante ?? null,
        hibrido: this.searchItens.codigo ?? null,
        comsaldo: this.searchItens.filtroSaldo,
        socomimagens: this.searchItens.filtroImagens,
        soemoferta: this.searchItens.filtroOferta,
        nameoferta: this.searchItens.nameOferta,
      }
      return obj
    },
    /*
     * Debounce para busca de itens na API
     */
    async searchItem(type = 'item') {
      try {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.getDados(type)
        }, 500)
      } catch (error) {
        this.$toasted.error(error)
      }
    },

    /*
     * Realiza a busca dos itens na API
     */
    async getDados(type = 'item') {
      try {
        if (type === 'item') {
          this.page = 1
          this.goToTableTop()
        } else {
          this.page = this.page + 1
        }
        this.searching = true
        await this.getItemsAPI({
          query: this.prepareSearchQuery(),
          type: type,
        })
        this.updateRodapeSelect()
        this.searching = false
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
    updateRodapeSelect($event = null) {
      this.dadosRodape = []
      if ($event) this.dadosRodape.push($event)
      else {
        // prioridade é do currentList (lista ordenada pelo v-data-table)
        if (this.currentList && this.currentList.length > 0)
          this.dadosRodape.push(this.currentList[this.indexRowSelected])
        else if (this.itemListComputed && this.itemListComputed.length > 0)
          this.dadosRodape.push(this.itemListComputed[this.indexRowSelected])
      }
    },
    closeOverlay() {
      this.overlay.overlay = false
    },
    toogleOverlay(item = null) {
      const imagensName = ['IMAGEM', 'IMAGEM1', 'IMAGEM2', 'IMAGEM3']
      this.imagesList = []
      this.overlay.model = 0
      this.overlay.item = item
      if (item && item.imagens) {
        this.overlay.overlay = !this.overlay.overlay
        this.overlay.especificacoes = item.imagens.especificacoes
        imagensName.forEach((key) => {
          if (item.imagens.images_base64[key]) {
            let path =
              'data:image/jpg;base64,' + item.imagens.images_base64[key]
            this.imagesList.push(path)
          }
        })
      }
    },
    selectAllToggle(props) {
      if (this.selected.length > 0) {
        this.selected = []
        return
      }
      if (
        this.selected.length !=
        this.itemListComputed.length - this.disabledCount
      ) {
        this.selected = []
        const self = this
        props.items.forEach((item) => {
          if (!item.disableSelect) {
            self.selected.push(item)
          }
        })
      } else this.selected = []
    },
    contextMenu: function(e) {
      e.preventDefault()
      this.showMenu = false
      this.contextMenuConfig.positionX = e.clientX
      this.contextMenuConfig.positionY = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    openMessageDialog(type) {
      this.messageToDialog = []
      let message = []
      if (type === 'valorcambio') {
        this.currency.forEach((cambio) => {
          if (cambio.CAMBIO0 > 0)
            message.push(this.formatCurrency(0, cambio.CAMBIO0))
          if (cambio.CAMBIO1 > 0)
            message.push(this.formatCurrency(1, cambio.CAMBIO1))
          if (cambio.CAMBIO2 > 0)
            message.push(this.formatCurrency(2, cambio.CAMBIO2))
          if (cambio.CAMBIO3 > 0)
            message.push(this.formatCurrency(3, cambio.CAMBIO3))
          if (cambio.CAMBIO4 > 0)
            message.push(this.formatCurrency(4, cambio.CAMBIO4))
          if (cambio.CAMBIO5 > 0)
            message.push(this.formatCurrency(5, cambio.CAMBIO5))
          if (cambio.CAMBIO6 > 0)
            message.push(this.formatCurrency(6, cambio.CAMBIO6))
        })
      }
      if (type === 'saldosfiliais' && this.dadosRodape.length > 0) {
        this.dadosRodape.forEach((item) => {
          message.push(`${this.$t('labels.codigo')} ${item.CODIGO}`)
          item.saldosDepartamentos.forEach((saldo) => {
            message.push(
              `${this.$t('labels.departamento')} ${saldo.DESCRICAO}: ${
                saldo.SALDODEPARTAMENTO
              }`
            )
          })
          if (item.saldosFiliais.length > 0) {
            item.saldosFiliais.forEach((saldo) => {
              message.push(
                `${this.$t('labels.filial')} ${saldo.FILIAL}: ${parseFloat(
                  saldo.SALDOITEM
                )}`
              )
            })
          }
        })
      }

      if (message.length > 0) {
        this.messageToDialog = message
        this.showMessageDialog = true
      }
    },
    selectOption(e, option) {
      clearTimeout(this.timer)
      if (option.value == 'itensselecionados') {
        this.onlySelected = !option.checked
        return
      }
      if (option.value == 'saldosfiliais') {
        this.openMessageDialog(option.value)
        return
      }
      if (option.value == 'socomsaldo')
        this.searchItens.filtroSaldo = !option.checked
      if (option.value == 'socomfotos')
        this.searchItens.filtroImagens = !option.checked
      if (option.value == 'soemoferta')
        this.searchItens.filtroOferta = !option.checked
      this.timer = setTimeout(() => {
        this.getDados()
      }, 600)
    },
    updateFullScreen() {
      this.fullscreen = !this.fullscreen
    },
    updateHeightTable(breakpointName = 'lg') {
      const size = {
        default: {
          xs: '100vh',
          sm: '52vh',
          md: '50vh',
          lg: '54vh',
          xl: '64vh',
        },
        fullscreen: {
          xs: '100vh',
          sm: '64vh',
          md: '62vh',
          lg: '70vh',
          xl: '78vh',
        },
      }
      if (this.fullscreen) return size.fullscreen[breakpointName]
      else return size.default[breakpointName]
    },
  },
  props: {
    componentOwner: {
      type: String,
      default: 'PDV',
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
    isGuest: {
      type: Boolean,
      default: false,
    },
    integration: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style>
.focused-line {
  background-color: rgb(59, 53, 53) !important;
}
.saldo-minimo {
  color: #bd200d !important;
  font-weight: bold;
}
</style>
